import React, { Component } from 'react';
import { Container, Row, Col, Tabs, Tab, Card } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import Signin from './Signin';
import { useNavigate } from "react-router-dom";

class SigninWrapWithParams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: this.props.option,
      navigate: this.props.navigate,
      newUser: true,
      right: 0,
    };
    console.log('SignupLoginWrap ', this.props);
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>VIZFM Signin</title>
          <link rel="canonical" href="https://www.vizfm.com/signin" />
          <meta name="description" content="VIZFM Signin Screen for Portfolio, Watchlist, alerts, updated news, market directions" />
        </Helmet>
        <Container fluid className="p-2">
          <Row className="justify-content-md-center">
            <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <Card style={{ backgroundColor: '#f6f6f6' }}>
                <Card.Body>
                  <Tabs fill defaultActiveKey={'signin'} id="uncontrolled-tab-example" className="mb-3">
                    <Tab eventKey="signin" title="Sign In" disabled>
                      <Signin navigate={this.state.navigate}/>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function SigninWrap(props) {
  let navigate = useNavigate();
  // let params = useParams();
  return <SigninWrapWithParams {...props} navigate={navigate} />
}

export default SigninWrap;
